var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.qrCodeContainer },
    [
      _c(
        "transition-group",
        {
          attrs: {
            enterClass: _vm.$style.fadeTo,
            enterActiveClass: _vm.$style.qrFadeTransition,
            leaveActiveClass: _vm.$style.qrFadeTransition,
            leaveToClass: _vm.$style.fadeTo,
          },
        },
        [
          _vm.qrImageLoading
            ? _c(
                "div",
                { key: "loadingContent", class: _vm.$style.loadingContent },
                [_c("LoadingIcon")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.qrImageLoading
            ? _c("img", {
                key: "qrImage",
                class: _vm.$style.qrCode,
                attrs: { src: _vm.qrCodeSrc },
              })
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }